<template>
  <Intro />
  <BookAppointment />
</template>

<script setup lang="ts">
import Intro from "@/components/bookYourAppointment/BookYourAppointmentIntro.vue";
import BookAppointment from "@/components/bookYourAppointment/BookAppointment.vue";
//import ContactUs from "@/components/shared/footer/ContactUs.vue";

import { computed, onMounted, ref, toRefs } from "vue";

onMounted(async () => {
  //debugger;
  // window.scrollTo(0, 0);
});
</script>

